<template>
    <div>
        <div v-for="section in sections" :key="section.id" class="px-4 pt-0 mt-1 pb-0 mb-4 rounded-lg bg-white hover:bg-blue-50 border border-white hover:border-gray-200">
            <div class="w-full mb-1 text-lg flex mt-2">
                <div class="flex-1 flex-grow" v-text="section.name"></div>
                <ui-toggle class="inline-block w-auto p-0.5 rounded-xl mr-4" field="text-xs"
                           v-model="split.tasks"
                           :text="`Split Tasks`"
                           :field="'text-gray-900'"
                ></ui-toggle>
            </div>
            <div v-if="split.tasks && section.tasks.length">
                <resource-planning-report-material-tasks :tasks="section.tasks"
                                                         :split="split">
                </resource-planning-report-material-tasks>
            </div>
            <div class="pb-4" v-else>
                <div v-if="section.materials.length"
                     class="flex mt-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                    <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Material
                    </div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Required
                    </div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Requested</div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Ordered
                    </div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Received</div>
                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Still
                        Required
                    </div>
                </div>
                <div
                    class="flex mt-2 p-2 border rounded-lg border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold"
                    v-else-if="section.tasks.length">
                    No materials for this section
                </div>
                <div
                    class="flex mt-2 p-2 border rounded-lg border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold"
                    v-else>
                    No tasks for this section
                </div>
                <resource-planning-report-material-item
                    v-for="(material,index) in section.materials" :item="material"
                    :key="index">
                </resource-planning-report-material-item>
            </div>
        </div>
    </div>
</template>

<script>

import UiToggle from "../ui/UiToggle.vue";
import {resolveNumericText, toCurrency, uuid} from "../../utils";
import {ResourcePlanningReport} from "@models";
import ResourcePlanningReportMaterialItem from "./ResourcePlanningReportMaterialItem.vue";
import ResourcePlanningReportBudget from "./ResourcePlanningReportBudget.vue";
import {array} from "i/lib/util";

export default {
    components: {
        ResourcePlanningReportBudget,
        ResourcePlanningReportMaterialItem,
        UiToggle,
    },
    props: {
        sections: array,
        split: Object,
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
    async mounted() {
    }
};
</script>
